import type { BusinessEmailEventTemplateData } from "../../../shared/types";
import BaseWriteApi from "../../core/BaseWriteApi";

export default class BusinessEmailDataApi extends BaseWriteApi<BusinessEmailEventTemplateData> {
  /* PRIVATE APIS */

  /* NEEDED BASE API OVERRIDES */

  get db() {
    return `${this.dbPrefix}business_email_data`;
  }
}
